import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import {getFormValues} from '../../helpers/Fields';
import * as User from '../../helpers/User';
import Inputgenerator from '../../components/Inputgenerator';

const $= window.$;

class Feedback extends Component {
	constructor(props) {
		super(props);

        this.state={
            ass_id : this.props.params.ass_id,
            poll_id : this.props.params.poll_id,
            learner : this.props.params.lr_id,
            domain : this.props.params.domain,
            questions : [],
            ques:[],
            assessor_name : '',
            learner_img :'',
            dated : '',
            is_answered : 0,
            lr_name :'',
        };

        this.getFeedback = this.getFeedback.bind(this);
        this.submit = this.submit.bind(this);

	}

    getFeedback(){
    	let asses_id = this.state.ass_id;
    	let pollid = this.state.poll_id;
    	let learner_id = this.state.learner;
    	let doma = this.state.domain;
    	fetch(Config.domainUrl+'personal/feedback-questions', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    assessor_id : asses_id,poll_id:pollid,learner_id:learner_id,domain:doma,
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               //	alert(JSON.stringify(responseJson));
               	if(responseJson.status != 0 ){

	               	this.setState({
		                ques : responseJson.questions,
	               		questions:responseJson.questions.questions,
	               		assessor_name:responseJson.extra.asse_name,
	               		learner_img:responseJson.extra.lr_img,
	               		dated:responseJson.extra.date,
	               		is_answered:responseJson.extra.is_answered,
	               		lr_name :responseJson.extra.lr_name,
	               	});
               	}

   		 });
    }


    componentDidMount() {
    	this.getFeedback();
    	let div = document.querySelector('body');
		div.id = 'bodyid';
		div.setAttribute('class','inner');

    }


    submit(e){
    	 Common.reactLoader("show", "Please wait...");
		//let learnerID = Common.getUserData("id", true);
		let asses_id = this.state.ass_id;
    	let pollid = this.state.poll_id;
    	let learner_id = this.state.learner;
		let jsonFormData = getFormValues(this.state.ques);

	      // alert(JSON.stringify(jsonFormData));
	       fetch(Config.domainUrl +"personal/observer-vote", {
	        method: "POST",
	        //data: formData,

	       headers: {
	           'Accept': 'application/json',
	           'Content-Type': 'application/json',
			   'Authorization':'Bearer ' +Common.getTokenData()
	          },
	        body:JSON.stringify({
                json_form_data: jsonFormData,asses_id:asses_id,pollid:pollid,learner_id:learner_id              }),
	       }).then((response) => response.json()).then((responseJson) => {
	       	 Common.reactLoader("hide");
	       	 	//alert(JSON.stringify(responseJson));
	       		 if (responseJson.status == 0) {
			        Common.message(responseJson.message, responseJson.errors, "error");
			      } else {
			      	let content ='<span class="redtext">'+responseJson.message+'</span><br/>'+' -'+this.state.lr_name;
			        //Common.message("", 'Thank you for your valuable feedback.', "success");
			        $("#maincontent").html(content);
			      }
	       });

    }




		render() {
			let ques = '';
			let length='';
			if(this.state.questions!=undefined){
				ques = this.state.questions.map((ques,i)=>{
					// let ans = ques.answers.map((answ,k)=>{
					// 	if(answ.choice != ""){
					// 		return(

					// 			)
					// 	}
					// })

					if(ques.questionLabel != ""){

						return(
								<div key={`question_${i}`} align="left" id={"div_snappoll"+i}>
									<span className="poll_centerbg_mail_snap">{ques.questionLabel}</span>
										<input type="hidden" name={"hidqid"+i} id={"hidqid"+i} value={ques.questionId} />
										<input type="hidden" name={"hidtype"+i} id={"hidtype"+i} value={ques.questionTypeId} />
										<div className="poll_txt_mail_snap">
										<span key={`answ_${i}`} className="fdbkradio"><Inputgenerator key={`quess_inputgenerator_${i}`} qDetails={ques} /></span>
										</div>
								</div>
							)
					}

				})
				length = this.state.questions.length;
			}


			let monthNames = Common.monthNames;
			let d=new Date(), jDate=d.getDate(), jMonth=monthNames[d.getMonth()], jYear=d.getFullYear();

			return (
				!this.state.is_answered
				?
				<div className="row">
					<header>
						<div className="logo"><img src={process.env.PUBLIC_URL+'/images/logo.png'} alt="361°minds&trade;" title="361°minds&trade;" border="0"/></div>
						<div className="top-links reg-page"><img src={process.env.PUBLIC_URL+'/images/calendar_icon.png'} alt="" title="" border="0"/>{this.state.dated}</div>
					</header>
					<section className="maincontent">
						<section className="content">
							<div id="maincontent">
								<table align="center" border="0" width="100%">
										<tr>
											<td colSpan="2">
												<table cellPadding="0" cellSpacing="0" border="0" width="100%">
													<tr><td colSpan="2"><h3>Hi {this.state.assessor_name}</h3></td></tr>
													<tr><td height="28" colSpan="2"></td></tr>
													<tr>
														<td valign="top" width="10%"><span dangerouslySetInnerHTML={{__html: this.state.learner_img}}/></td>
														<td >
															I value your feedback immensely.
															<br /><br />
															I request you to let me know your thoughts about me, by answering the questions below. I look forward to your 100% true feedback, as it is going to help me greatly.
															<br /><br />
														</td>
													</tr>
												</table>
											</td>
										</tr>
										<tr><td colSpan="2"></td></tr>
										<tr>
											<td colSpan="2" >
												<form name="assessor_snap_form" id="assessor_snap_form">
													{ques}
													<input type="hidden" name="no" id="no" value={length} />
													<div class="button margtop"><span><input type="button" name="btnSubmit" value="Submit" onClick={(e)=>this.submit(e)} /></span></div><br /><br />
												</form>
											</td>
										</tr>
								</table>
							</div>
						</section>
					</section>
					<footer>
						<span>Copyright &copy; 2006-{jYear},</span>
						<span>Threesixtyone Degree Minds Consulting Pvt Ltd.</span>
						<span className="f-lnk"><a href="javascript:void(0);">Privacy</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0);">Legal</a></span>
					</footer>
				</div>
				:
				<div className="row">
					<header>
						<div className="logo"><img src={process.env.PUBLIC_URL+'/images/logo.png'} alt="361°minds&trade;" title="361°minds&trade;" border="0"/></div>
						<div className="top-links reg-page"><img src={process.env.PUBLIC_URL+'/images/calendar_icon.png'} alt="" title="" border="0"/>{this.state.dated}</div>
					</header>
					<section className="maincontent">
						<section className="content">
							<div><span className="redtext">You have already submitted your feedback. Thank you</span><br /> - {this.state.lr_name}</div>

						</section>
					</section>
					<footer>
						<span>Copyright &copy; 20017-{jYear},</span>
						<span>Threesixtyone Degree Minds Consulting Pvt Ltd.</span>
						<span className="f-lnk"><a href="javascript:void(0);">Privacy</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0);">Legal</a></span>
					</footer>
				</div>

			);
		}
}

export default Feedback;



// WEBPACK FOOTER //
// ./src/personal_interactions/iseek/Feedback.js